import i18n from '@/user/plugins/i18n'

/**
 * 교육신청 정보
 * @property {string} applyState 신청완료(APPLIED, PAID), 수강완료(COMPLETED), 신청취소(CANCELED)
 */
export class AppliedStateInfo {
  constructor(props) {
    this.applyState = props.applyState
    this.progressState = props.progressState
  }

  /**
   * 현재 교육신청 상태 다국어 지원
   * @return {string} 신청완료, 수강완료, 신청취소
   */
  getApplyState() {
    switch (this.applyState) {
      case 'APPLIED':
      case 'PAID':
        return i18n.global.t('eduCenter.account.state.applied')
      case 'CANCELED':
        return i18n.global.t('eduCenter.account.state.canceled')
      case 'DROPPED':
        return i18n.global.t('eduCenter.account.state.dropped')
    }
  }

  get cancelableState() {
    return this.applyState === 'APPLIED' || this.applyState === 'PAID'
  }

  get isCanceled() {
    return this.applyState === 'CANCELED'
  }

  get isScheduled() {
    return this.progressState === 'SCHEDULED'
  }

  get isPrepared() {
    return this.progressState === 'PREPARED'
  }
}
